import React from 'react'
import Link from 'next/link'
import { Header2, Text } from '../../styles/Components'
import { FAQsWrapper } from './styles'

const FAQsCTA = () => (
  <FAQsWrapper aria-label="Frequently asked questions">
    <Header2 align="center" lineHeight="1.2" margin="0">Have questions?</Header2>
    <Text fontSize={16} lineHeight="1.38" spacing={0.96} textAlign="center">
      <Link
        href="/faq"
        className="faq-link"
      >
        Check out our FAQs.
      </Link>
    </Text>
  </FAQsWrapper>
)

export default FAQsCTA
